/**
 * Lectures Timestamp Cell - Frontend
 * @description Cell component for displaying timestamp in LecturesTable
 */

import React from 'react';
import { CellContext } from '@tanstack/react-table';
import { LecturesTableData } from '@/types/operational-ui.types';
// import { formatRelativeTime } from '@/utils/operational-ui.utils';
import { formatDateAsYearMonthDayHourMinute } from '@/utils/formatters/dateFormatter';

interface LecturesTimestampCellProps {
  info: CellContext<LecturesTableData, string>;
}

export const LecturesTimestampCell: React.FC<LecturesTimestampCellProps> = ({ info }) => {
  const timestampValue = info.getValue();
  const row = info.row.original;
  const timeZone = row?.tz;

  return (
    <div className="text-sm">
      <div className="flex items-center text-gray-900">
        {formatDateAsYearMonthDayHourMinute(timestampValue, timeZone)}
      </div>
    </div>
  );
};
